var ADOBE_LINK_CLICK = 'link_click';
var ADOBE_ERROR = 'error_triggered';
var ADOBE_PAGE_LOAD = 'page_load';
var ADOBE_TRANSACTION = {
  START: 'transaction_start',
  STEP: 'transaction_step',
  COMPLETE: 'transaction_complete',
  ERROR: 'transaction_error'
};
var ADOBE_REGISTRATION = {
  START: 'registration_start',
  COMPLETE: 'registration_complete',
  ERROR: 'registration_error'
};
var ADOBE_LOGIN = {
  START: 'login_start',
  COMPLETE: 'login_complete',
  ERROR: 'login_error'
};export{ADOBE_ERROR,ADOBE_LINK_CLICK,ADOBE_LOGIN,ADOBE_PAGE_LOAD,ADOBE_REGISTRATION,ADOBE_TRANSACTION};